/* eslint-disable react/prop-types */
import React from 'react';
import { IncidentDetails } from './styles';
import { OutageIcon } from './OutageIcon';

function Incident({ incident }) {
  const endTtime = incident.end_time ? new Date(incident.end_time) : new Date();
  const timeDiff = endTtime - new Date(incident.start_time);
  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const formattedTimeDiff = `${hours}hrs ${minutes}mins`;
  const startTime = new Date(incident.start_time).toLocaleString('en-US', {
    timeZone: 'UTC',
    hour: 'numeric',
    minute: 'numeric',
  });
  const endTime = endTtime.toLocaleString('en-US', {
    timeZone: 'UTC',
    hour: 'numeric',
    minute: 'numeric',
  });
  return incident.id ? (
    <IncidentDetails>
      <div>
        {incident.category === 'maintenance' ? (
          <svg
            width="30"
            height="30"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 14C2 15.0609 2.42143 16.0783 3.17157 16.8284C3.92172 17.5786 4.93913 18 6 18H14C15.0609 18 16.0783 17.5786 16.8284 16.8284C17.5786 16.0783 18 15.0609 18 14V6C18 4.93913 17.5786 3.92172 16.8284 3.17157C16.0783 2.42143 15.0609 2 14 2H6ZM13.28 5.28C12.7202 5.01264 12.0913 4.9254 11.4798 5.03031C10.8684 5.13522 10.3045 5.42711 9.86579 5.86579C9.42711 6.30446 9.13522 6.86835 9.03031 7.4798C8.9254 8.09125 9.01264 8.72019 9.28 9.28L5.28 13.28C5.16538 13.366 5.07057 13.4756 5.002 13.6013C4.93342 13.7271 4.89267 13.8662 4.88252 14.0091C4.87236 14.152 4.89303 14.2954 4.94313 14.4297C4.99323 14.5639 5.07158 14.6858 5.17289 14.7871C5.2742 14.8884 5.3961 14.9668 5.53032 15.0169C5.66455 15.067 5.80798 15.0876 5.95089 15.0775C6.0938 15.0673 6.23286 15.0266 6.35865 14.958C6.48445 14.8894 6.59404 14.7946 6.68 14.68L10.68 10.68C11.2398 10.9474 11.8687 11.0346 12.4802 10.9297C13.0916 10.8248 13.6555 10.5329 14.0942 10.0942C14.5329 9.65554 14.8248 9.09165 14.9297 8.4802C15.0346 7.86875 14.9474 7.23981 14.68 6.68L12.68 8.68C12.594 8.79462 12.4844 8.88943 12.3587 8.958C12.2329 9.02658 12.0938 9.06733 11.9509 9.07748C11.808 9.08764 11.6646 9.06697 11.5303 9.01687C11.3961 8.96677 11.2742 8.88842 11.1729 8.78711C11.0716 8.6858 10.9932 8.5639 10.9431 8.42968C10.893 8.29545 10.8724 8.15202 10.8825 8.00911C10.8927 7.8662 10.9334 7.72714 11.002 7.60135C11.0706 7.47555 11.1654 7.36596 11.28 7.28L13.28 5.28Z"
              fill="#482764"
            />
          </svg>
        ) : (
          OutageIcon
        )}
      </div>
      <div className="incident-details">
        <div className="d-flex justify-content-between">
          <h5 className="incident-title">{incident.title}</h5>
        </div>
        {incident.affected_services && (
          <div className="incident-apps">
            <p>Applications Impacted:</p>
            {incident.affected_services.map(item => (
              <div
                className="incident-apps-name"
                key={incident.id + item.id}
                title={`${item.category}: ${item.impact_notes}`}
              >
                <p>{item.service_name}</p>
              </div>
            ))}
          </div>
        )}
        <div className="incident-timings">
          <p title={`Incident Duration: ${formattedTimeDiff}`}>
            {formattedTimeDiff}
          </p>
          <div className="incident-timings-time">
            <p title={`Incident Start Time: ${incident.start_time}`}>
              {startTime}
            </p>
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.53325 1.53334C5.65787 1.41119 5.82542 1.34277 5.99992 1.34277C6.17442 1.34277 6.34197 1.41119 6.46659 1.53334L9.46659 4.53334C9.58874 4.65796 9.65716 4.82551 9.65716 5.00001C9.65716 5.17451 9.58874 5.34206 9.46659 5.46668L6.46659 8.46668C6.3382 8.56296 6.1794 8.60971 6.01933 8.59833C5.85925 8.58696 5.70865 8.51822 5.59518 8.40475C5.48171 8.29127 5.41297 8.14068 5.4016 7.9806C5.39022 7.82053 5.43697 7.66173 5.53325 7.53334L7.33325 5.66668H0.999919C0.823108 5.66668 0.653538 5.59644 0.528514 5.47142C0.40349 5.34639 0.333252 5.17682 0.333252 5.00001C0.333252 4.8232 0.40349 4.65363 0.528514 4.52861C0.653538 4.40358 0.823108 4.33334 0.999919 4.33334H7.33325L5.53325 2.46668C5.4111 2.34206 5.34268 2.17451 5.34268 2.00001C5.34268 1.82551 5.4111 1.65796 5.53325 1.53334Z"
                fill="#4F5362"
              />
            </svg>
            <p title={`Incident End Time: ${incident.end_time}`}>{incident.actual_end_time ? endTime : 'Ongoing'}</p>
          </div>
        </div>
        <p className="incident-description">{incident.description}</p>
      </div>
    </IncidentDetails>
  ) : (
    <IncidentDetails>
      <div>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.033 3.333a13 13 0 0 1 5.934 0 7.63 7.63 0 0 1 5.7 5.7 13 13 0 0 1 0 5.934 7.63 7.63 0 0 1-5.7 5.7 13 13 0 0 1-5.934 0 7.63 7.63 0 0 1-5.7-5.7 13 13 0 0 1 0-5.934 7.63 7.63 0 0 1 5.7-5.7m6.034 7.134a.578.578 0 0 0-.834-.8L11.3 12.833l-1.5-1.5a.567.567 0 0 0-.8.8l1.9 1.9a.57.57 0 0 0 .833 0z"
            fill="#19814E"
          />
        </svg>
      </div>
      <div className="incident-details" style={{ marginBottom: 0 }}>
        <h5 className="incident-title" style={{ marginBottom: 0 }}>
          All Services are Operational
        </h5>
      </div>
    </IncidentDetails>
  );
}

export default Incident;
